import React from "react";
import { Collapse, Tooltip } from "antd";
import BasicSetting from "./BasicSetting";
import CardSetting from "./CardSetting";
import AxisSetting from "./AxisSetting";
import informationButton from "../../../assets/information-button.svg";
import { useSelector } from "react-redux";

const { Panel } = Collapse;

const ChartSettingCard = ({ yAxis }) => {
  const onChange = (key) => {};
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );

  const widgetMakerGraphData1 = useSelector(
    (state) => state?.WidgetAPI?.widget_maker_graph_data
  );

  const widgetMakerGraphData =
    typeof widgetMakerGraphData1 === "string"
      ? widgetMakerGraphData1
      : widgetMakerGraphData1?.data?.[
          widgetGraphConfig?.chart_type === "combination"
            ? "combination"
            : widgetGraphConfig?.chart_type === "horizontal-bar"
            ? "bar"
            : widgetGraphConfig?.chart_type === "donut"
            ? "pie"
            : widgetGraphConfig?.chart_type
        ];

  return (
    <Collapse
      bordered={false}
      className="bg__white"
      expandIconPosition="right"
      defaultActiveKey={["2"]}
      onChange={onChange}
      accordion
    >
      <Panel className="border-color" header="Chart" key="1">
        <BasicSetting />
      </Panel>
      {widgetGraphConfig?.chart_type !== "cluster-chart" &&
        widgetGraphConfig?.chart_type !== "post-card" &&
        widgetGraphConfig?.chart_type !== "news-card" &&
        widgetGraphConfig?.chart_type !== "prolific-user" &&
        widgetGraphConfig?.chart_type !== "review-card" &&
        widgetGraphConfig?.chart_type !== "author-card" &&
        widgetGraphConfig?.chart_type !== "survey-card" &&
        widgetGraphConfig?.chart_type !== "rich-text" && (
          <Panel
            collapsible={!widgetMakerGraphData ? "disabled" : ""}
            className="border-color CardSetting_Panel"
            header={
              <span>
                Cards
                {widgetGraphConfig?.chart_type !== "kpi" && (
                  <Tooltip placement="top" title="KPI cards limit is 15">
                    <img
                      src={informationButton}
                      alt="Info"
                      className="cursor-pointer ml-2"
                      style={{ maxWidth: "1.6rem" }}
                    />
                  </Tooltip>
                )}
              </span>
            }
            key="2"
          >
            <CardSetting />
          </Panel>
        )}
      {widgetGraphConfig?.chart_type === "donut" ||
      widgetGraphConfig?.chart_type === "pie" ||
      widgetGraphConfig?.chart_type === "grid" ||
      widgetGraphConfig?.chart_type === "bubble" ||
      widgetGraphConfig?.chart_type === "map" ||
      widgetGraphConfig?.chart_type === "rich-text" ||
      widgetGraphConfig?.chart_type === "treemap" ||
      widgetGraphConfig?.chart_type === "sunburst" ||
      widgetGraphConfig?.chart_type === "cluster-chart" ? (
        ""
      ) : (
        <>
          {yAxis &&
            Object?.values(yAxis)?.map((data, i) => {
              return (
                data?.attribute && (
                  <Panel
                    className="border-color"
                    header={`${
                      ["scatter", "multilayer-map"]?.includes(
                        widgetGraphConfig?.chart_type
                      )
                        ? "Series"
                        : "Y-Series"
                    } ${i + 1}`}
                    key={i === 0 ? "3" : 3 + i}
                  >
                    <AxisSetting yAxis={data} listIndex={i} />
                  </Panel>
                )
              );
            })}
        </>
      )}
    </Collapse>
  );
};

export default ChartSettingCard;
